import { Stack, IconButton, Link } from "@mui/material";
import RoomIcon from '@mui/icons-material/Room';

function AddressLink() {
  return (
    <Stack direction="row" spacing={1} justifyContent="center" alignItems="center">  
      <IconButton
        color="primary"
        component={Link}
        href={process.env.REACT_APP_GOOGLE_MAPS_HREF}
        target="_blank"
        rel="noopener noreferrer"
        sx={{ color: '#fff', fontSize: 14 }}
      >
        <RoomIcon />
      </IconButton>
      <Link href={process.env.REACT_APP_GOOGLE_MAPS_HREF} target="_blank" rel="noopener" sx={{ color: '#fff', fontSize: 14 }}>
        Helmitauluntie 7, 02770 Espoo
      </Link>
    </Stack>
  )
}

export default AddressLink;